/* ÖZB Motion — giriş animasyonları + odometre sayaç.
   1) .ozb-anim öğeleri görünür alana girince .ozb-in alır.
   2) [data-ozb-odo="72"] öğesi rakam şeridine dönüşür ve görünürlükte döner. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window)) {
    document.documentElement.classList.add('ozb-motion-off');
    return;
  }

  /* ---------- 1) Reveal ---------- */
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('ozb-in');
        revealIO.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function bindReveal(root) {
    (root || document).querySelectorAll('.ozb-anim:not(.ozb-in)').forEach(function (el) {
      revealIO.observe(el);
    });
  }

  /* ---------- 2) Odometre ---------- */
  function buildOdo(el) {
    var target = String(el.getAttribute('data-ozb-odo') || '').replace(/[^0-9]/g, '');
    if (!target || el.dataset.ozbOdoReady) return;
    el.dataset.ozbOdoReady = '1';
    el.classList.add('ozb-odo');
    el.textContent = '';

    target.split('').forEach(function (digit, i) {
      var d = document.createElement('span');
      d.className = 'ozb-odo-d';
      var strip = document.createElement('span');
      strip.className = 'ozb-odo-strip';
      strip.style.setProperty('--d', (i * 0.12) + 's');
      for (var n = 0; n <= 9; n++) {
        var s = document.createElement('span');
        s.textContent = String(n);
        strip.appendChild(s);
      }
      d.appendChild(strip);
      el.appendChild(d);
      d._strip = strip;
      d._target = parseInt(digit, 10);
    });

    if (reduce) rollOdo(el);
  }

  function rollOdo(el) {
    if (el.dataset.ozbOdoDone) return;
    el.dataset.ozbOdoDone = '1';
    Array.prototype.forEach.call(el.children, function (d) {
      if (d._strip) d._strip.style.transform = 'translateY(-' + (d._target * 10) + '%)';
    });
  }

  var odoIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        rollOdo(e.target);
        odoIO.unobserve(e.target);
      }
    });
  }, { threshold: 0.4 });

  function bindOdo(root) {
    (root || document).querySelectorAll('[data-ozb-odo]').forEach(function (el) {
      buildOdo(el);
      if (!reduce) odoIO.observe(el);
    });
  }

  function init(root) { bindReveal(root); bindOdo(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Tema editöründe section yeniden yüklenince tekrar bağla */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
